/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Primarystudyinterest_Study_Philosophy17Inputs */

const en__field__enum_primarystudyinterest_study_philosophy17 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Philosophy17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Philosophy`)
};

const de__field__enum_primarystudyinterest_study_philosophy17 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Philosophy17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Philosophie`)
};

/**
* | output |
* | --- |
* | "Philosophy" |
*
* @param {_Field__Enum_Primarystudyinterest_Study_Philosophy17Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_primarystudyinterest_study_philosophy17 = /** @type {((inputs?: _Field__Enum_Primarystudyinterest_Study_Philosophy17Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Primarystudyinterest_Study_Philosophy17Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_primarystudyinterest_study_philosophy17(inputs)
	return de__field__enum_primarystudyinterest_study_philosophy17(inputs)
});
export { _field__enum_primarystudyinterest_study_philosophy17 as "_field__enum_primaryStudyInterest_STUDY_PHILOSOPHY" }